module.exports = __webpack_public_path__ + "img/06.73319be5.png";